import React, { useEffect, useState } from 'react'; // Import useEffect and useState
import axios from 'axios'; // Import axios
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon
import { faMagnifyingGlass, faRightFromBracket } from '@fortawesome/free-solid-svg-icons'; // Import specific icons
import { LinkIcon } from "@heroicons/react/24/outline";
import LoadingAnimation from './LoadingAnimation';

import SiteSurvey from './orders/SitesSurvery';
import Installation from './orders/Installation';
import { S3Client, PutObjectCommand, GetObjectCommand } from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';

const HomeBackend = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Updated to 10 items per page
  const navigate = useNavigate();
  const [totalOrganizations, setTotalOrganizations] = useState(0);
  const [loading, setLoading] = useState(true); // Loading state
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpensite, setIsOpensite] = useState(false);
  const [approvalType, setApprovalType] = useState('normal');
  const [attachment, setAttachment] = useState(null);
  const [recordType, setrecordType] = useState("cheque");
  const [attachmentPreview, setAttachmentPreview] = useState(null); // For image preview
  const [id, setid] = useState(null)
  const [comment, setComment] = useState('');
  const [amount, setAmount] = useState('');
  const [selectpreoderid, setselectedoderid] = useState("")
  const [siteSurvey, setSiteSurvey] = useState({
    DateofSiteSurvey: null,
    siteSurveycomment:"",
    TimeofSiteSurvey: null
  })
  const [installationDetails, setInstallationDetails] = useState({
    DateofInstallation: null,
    TimeofInstallation: null,
    installtioncomment:""
  })
  const [isOpenInstallation,setIsOpenInstallation]=useState(false)

  const toggleModal = () => setIsOpen(!isOpen);

  const s3Client = new S3Client({
    region: 'ap-south-1',
    credentials: {
      accessKeyId: `${process.env.REACT_APP_S3_ACCESS_KEY}`,
      secretAccessKey: `${process.env.REACT_APP_S3_SECERET_KEY}`
    },
  });

  
  
 
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setAttachment(file);

    // Generate a preview URL for the image
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => setAttachmentPreview(e.target.result);
      reader.readAsDataURL(file);
    } else {
      setAttachmentPreview(null); // Clear preview if not an image
    }
  };

  const removeAttachment = () => {
    setAttachment(null);
    setAttachmentPreview(null);
  };
  let currentItems = []

  const uploadPdfToS3 = async (pdfBlob, fileName) => {
    console.log("inside the upload api");
    console.log(`${process.env.REACT_APP_AWS_BUCKET_NAME}`);
    try {
      const command = new PutObjectCommand({
        Bucket: `${process.env.REACT_APP_AWS_BUCKET_NAME}`,
        Key: `invoices/${fileName}`,
        Body: pdfBlob,
        ContentType: 'application/pdf',
      });
      const uploadResponse = await s3Client.send(command);;
      console.log('PDF uploaded successfully:', uploadResponse);
      return `https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/${fileName}`; // Return the public URL of the uploaded file
    } catch (error) {
      console.error('Error uploading PDF to S3:', error);
      throw new Error('Failed to upload PDF');
    }
  };
  const generatePresignedUrl = async (fileName) => {
    try {
      const command = new GetObjectCommand({
        Bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
        Key: `invoices/${fileName}`,
      });
      const presignedUrl = await getSignedUrl(s3Client, command, { expiresIn: 3600 }); // URL valid for 1 hour
      console.log('Generated Pre-Signed URL:', presignedUrl);
      return presignedUrl;
    } catch (error) {
      console.error('Error generating pre-signed URL:', error);
      throw new Error('Failed to generate pre-signed URL');
    }
  };


  const sendApprovalRequest = async (imageUrl) => {
    setLoading(true); // Start loading state
    try {
        // Fetch the existing preorder data to get current transactions and pending amount
        const currentDataResponse = await axios.get(`${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${id}`);
        
        const currentTransactions = currentDataResponse.data.aproveldata?.transactions || [];
        const pendingAmount = parseInt(currentDataResponse.data.pending_amount || 0);
        // console.log(pendingAmount,"checkamount")
        // Calculate the total of existing amounts
        const currentTotalAmount = parseInt(currentTransactions.reduce((sum, transaction) => sum + transaction.amount, 0));
        let Totalamount=currentTotalAmount+parseInt(amount)
        // Validate the new amount
        if (Totalamount > pendingAmount) {
            setLoading(false); // End loading state
            alert(`The total amount exceeds the pending amount of ${pendingAmount}. Please enter a valid amount.`);
            return;
        }

        // Create a new array with the existing transactions and the new one
        const updatedTransactions = [
            ...currentTransactions, // Include existing transactions if any
            { amount, attachmentUrl: imageUrl } // Add the new transaction
        ];

        // Update the preorder data with the new list of transactions
        const response = await axios.put(
            `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/recordpayment/${id}`,
            {
                transactions: updatedTransactions, // Updated list of transactions
                comment,                           // Optional: Comment field
                approvalType,                      // Optional: Approval type
                approvalStatus: false,
                recordType                         // Optional: Record type
            }
        );

        console.log("Approval data updated successfully:", response.data);
        setLoading(false); // End loading state
    } catch (error) {
        setLoading(false); // End loading state
        console.error("Error sending approval request:", error.response ? error.response.data : error.message);
    }
};



  const sendFileToServer = async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      // Send the file to the backend
      const response = await axios.post(`${process.env.REACT_APP_MYBACKEND_PI}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data.normalUrl
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };


  const handleSubmit = async () => {
    // Validation logic for approvalType "normal" and "special"
    if (!approvalType) {
      alert("Approval type is required.");
      return;
    }

    if (approvalType === "normal") {
      // For "normal" approvalType, comment is optional
      if (!amount || !attachment) {
        const missingFields = [];
        if (!amount) missingFields.push("Amount");
        if (!attachment) missingFields.push("Attachment");
        if (!recordType) missingFields.push("Document")
        alert(`The following fields are missing: ${missingFields.join(", ")}`);
        return;
      }
    } else if (approvalType === "special") {
      // For "special" approvalType, only comment is required
      if (!comment) {
        alert("Comment is required for special approval.");
        return;
      }
    }

    // Check if attachment is a valid image file
    if (attachment && !attachment.type.startsWith('image/')) {
      alert("Only image files are allowed.");
      return;
    }
    if (amount) {
      const confirmMessage = `💰 You have entered an amount of ₹${amount}.❓ Do you want to proceed?`;
      const isConfirmed = window.confirm(confirmMessage);
      if (!isConfirmed) {
          // User canceled the submission
          return;
      }
  }
  

    try {
      setLoading(true);

      // Step 1: Upload image to S3 if attachment exists
      let imageUrl = '';
      if (attachment) {
        imageUrl = await sendFileToServer(attachment);
      }

      // Step 2: Send the approval request
      await sendApprovalRequest(imageUrl);
      setIsOpen(!isOpen);
      alert("Submission successful!");
    } catch (error) {
      console.error("Error during submission:", error);
      alert("Failed to process the request. Please try again.");
    } finally {
      // Reset the state after the approval request is completed
      setLoading(false);
      setAmount(''); // Reset the amount field
      setComment(''); // Reset the comment field
      setAttachment('');
      setrecordType('');
    }
  };

  const handleOrderCreation = () => {
    navigate("/orders");
  };
  useEffect(() => {
    // Fetch data when the component mounts
    fetchData();
  }, []);


  const fetchData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      });
      console.log(response.data, "jitudata")
      setData(response.data);
      setTotalOrganizations(response.data.length);
    } catch (error) {
      console.error("Error creating PreOrder:", error.response ? error.response.data : error.message);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };

  // Filter data based on search query
  useEffect(() => {
    setFilteredData(
      data.filter((item) =>
        item.customer.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );

  }, [searchQuery, data]);

  // Calculate pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/');
  };
  const quryhandler = () => {

    window.open(`${process.env.REACT_APP_RISE_QUERY}`, '_blank');
  };




  const createInstallationItem = (type, quantity, charge, itemId) => {
    if (quantity > 0 && charge > 0) { // Check if charge is also valid
      const unitPrice = charge / 1.28; // This assumes 28% tax
      return {
        id: itemId,
        name: `Installation (${type} AC)`,
        quantity: quantity,
        unit_price: unitPrice,
        tax_rate: 28,
        price_with_tax: charge,
        item_type: 'Service',
        net_amount: unitPrice * quantity,
        total_amount: charge * quantity,
      };
    }
    return null; // Return null if quantity or charge is invalid
  };
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const mapProduct = (acModel, item) => {
    const models = {
      '10': {
        id: 'mlmc_3y_1t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 1T',
        unitPrice: 1014.84,
        priceWithTax: 1299,
      },
      '15': {
        id: 'mlmc_3y_1.5t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 1.5T',
        unitPrice: 1092.97,
        priceWithTax: 1399,
      },
      '20': {
        id: 'mlmc_3y_2t_p', // Default for Split
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 2T',
        unitPrice: 1327.34,
        priceWithTax: 1699,
      },
      '30': {
        id: 'mlcmc_2y_3t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 2Y 30T',
      }
    };
    if (item.acType === 'Cassette') {
      models['20'] = {
        id: 'mlmc_cassette_5y_2t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 5Y 2T-Cassete',
        unitPrice: 1952.34,
        priceWithTax: 2499,
      };
      models['30'] = {
        id: 'mlmc_cassette_5y_3t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 5Y 3T-Cassete',
        unitPrice: 2342.96,
        priceWithTax: 2999,
      }
    }
    const model = models[acModel];

    if (!model) {
      throw new Error('Invalid acModel provided.');
    }

    let priceWithTax = Number(item.totalSubscription / item.quantity);
    let unitPrice = (item.totalSubscription / item.quantity) / 1.28;
    return {
      id: model.id,
      name: model.name,
      quantity: item.quantity,
      unit_price: unitPrice,
      tax_rate: 28,
      price_with_tax: priceWithTax,
      item_type: 'Service',
      net_amount: unitPrice * item.quantity,
      total_amount: item.totalSubscription
    };
  };

  const mapMaterial = (items) => {
    const materials = {
      "copper_piping_p": {
        "id": "copper_piping_p",
        "name": "Extra Installation - Piping",
        "unit_price": 350.728,
        "price_with_tax": 448.93184,
      },
      "copper_piping_cassette_p": {
        "id": "copper_piping_cassette_p",
        "name": "Extra Installation-Cassette - Piping",
        "unit_price": 350.728,
        "price_with_tax": 448.93184,
      },

      "core_cable_4_p": {
        "id": "core_cable_4_p",
        "name": "Polycab 4 Core Cable",
        "unit_price": 39.006,
        "price_with_tax": 49.92768,
      },
      "dismantling_charges_p": {
        "id": "dismantling_charges_p",
        "name": "Dismantling charges",
        "unit_price": 390.625,
        "price_with_tax": 500.0
      },
      "cross_stand_p": {
        "id": "cross_stand_p",
        "name": "Cross Stand",
        "unit_price": 1483.59,
        "price_with_tax": 1898.9952
      },
      "rubber_stand_p": {
        "id": "rubber_stand_p",
        "name": "Extra Installation - Rubber Stand",
        "unit_price": 233.59,
        "price_with_tax": 298.9952
      },
      "l_stand_p": {
        "id": "l_stand_p",
        "name": "L Stand",
        "unit_price": 467.97,
        "price_with_tax": 599.0016,
      },
      "jumbo_stand":{
        "id": "jumbo_stand",
        "name": "Jumbo Stand",
        "unit_price": 858.59375,
        "price_with_tax": 1099,
      },
      "uninstall_cassette_charges":{
        "id": "uninstall_cassette_charges",
        "name": "Uninstallation Charges_Cassette",
        "unit_price": 1171.875,
        "price_with_tax": 1500,
      },
      "add_on_split":{
        "id": "add_on_split",
        "name": "Add On Service - Split",
        "unit_price": 499,
        "price_with_tax": 499,
      },
      "add_on_cassette":{
        "id": "add_on_cassette",
        "name": "Add On Service - Cassette",
        "unit_price": 1499,
        "price_with_tax": 1499,
      },
      "relocation_cassette":{
        "id": "relocation_cassette",
        "name": "Relocation - Cassette",
        "unit_price": 5000,
        "price_with_tax": 5000,
      },
      "relocation_split":{
        "id": "relocation_split",
        "name": "Relocation - Split",
        "unit_price": 2000,
        "price_with_tax": 2000,

      }
    };

    // Check if items is an array
    if (!Array.isArray(items)) {
      alert('Expected an array but got:', items);
      return []; // Return an empty array instead of null
    }

    // Map over the provided items and dynamically build the material objects
    return items.map((item) => {
      const material = materials[item.materialType.toLowerCase().replace(/\s+/g, '_')];
      if (!material) {
        alert("Material type not found for:", item.materialType);
        return null; // If no matching material is found, return null
      }

      // Ensure quantity and price are numbers
      const quantity = Number(item.quantity);
      const price = Number(item.price);
      let priceWithTax = Number(item.totalAmount / quantity)
      let unitPrice = priceWithTax / 1.28;
      return {
        id: material.id,
        name: material.name,
        quantity: quantity, // Correctly formatted quantity
        unit_price: unitPrice, // Static unit price from materials
        tax_rate: 28, // Static tax rate
        price_with_tax: priceWithTax, // Total amount from input
        item_type: 'Product', // Static type 'Material'
        net_amount: unitPrice * quantity, // Net amount excluding tax
        total_amount: item.totalAmount // Total amount with tax
      };
    }).filter(item => item !== null); // Filter out any null values if materials are not found
  };
  const mapRefundableDeposit = (acModel, ton, duration, quantity, totalAmount) => {
    const refundableDeposits = {
      'Split': {
        '3year': {
          '10': {
            id: 'refund_3y_1t_p',
            name: 'Refundable Deposit - 1T',
          },
          '15': {
            id: 'refund_3y_1.5t_p',
            name: 'Refundable Deposit - 1.5T',
          },
          '20': {
            id: 'refund_3y_2t_p',
            name: 'Refundable Deposit - 2T',
          },
        },
        '5years': {
          '10': {
            id: 'refund_5y_1t_p',
            name: 'Refundable Deposit - 1T',
          },
          '15': {
            id: 'refund_5y_1.5t_p',
            name: 'Refundable Deposit - 1.5T',
          },
          '20': {
            id: 'refund_5y_2t_p',
            name: 'Refundable Deposit - 2T',
          },
        },
      },
      'Cassette': {
        '20': {
          id: 'refund_cassette_2t_p',
          name: 'Refundable Deposit - Cassette 2 Ton',
        },
        '30': {
          id: 'refund_cassette_3t_p',
          name: 'Refundable Deposit - Cassette 3 Ton',
        },
      },
    };
  
    // Check for valid AC model
    if (!refundableDeposits[acModel]) {
      alert(`Invalid AC model provided: ${acModel}`);
      return null;
    }
  
    let deposit;
    if (acModel === 'Split') {
      // Check for valid duration
      if (!refundableDeposits[acModel][duration]) {
        alert(`Invalid duration provided for Split AC: ${duration}`);
        return null;
      }
      // Check for valid tonnage
      deposit = refundableDeposits[acModel][duration][ton];
      if (!deposit) {
        alert(`Invalid tonnage provided for duration ${duration} in Split AC model: ${ton}`);
        return null;
      }
    } else if (acModel === 'Cassette') {
      // Check for valid tonnage
      deposit = refundableDeposits[acModel][ton];
      if (!deposit) {
        alert(`Invalid tonnage provided for Cassette AC model: ${ton}`);
        return null;
      }
    }
  
    // Calculate unit price and price with tax dynamically
   
    let priceWithTax = Number(totalAmount / quantity)
    let unitPrice = priceWithTax;
  
    return {
      id: deposit.id,
      name: deposit.name,
      quantity: Number(quantity),
      unit_price: parseInt(unitPrice.toFixed(2)),
      tax_rate: 0,
      price_with_tax: parseInt(priceWithTax.toFixed(2)),
      item_type: 'Service',
      net_amount: unitPrice*quantity,
      total_amount: totalAmount,
    };
  };
  


  const uploadInvoiceData = async (invoice) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_MYBACKEND_PI}/api/google-sheets`, { invoice });
    } catch (error) {
      console.log('Error uploading data to Google Sheets:', error.response ? error.response.data : error.message);

    }
  };
  



  const createPIInvoice = async (savedItems, materials, customerdata, selectedShippingAddress, billingAddress, splitInstallationCharge, cassetteInstallationCharge,pending_amount,preOrderId) => {

    try {
      // Proceed with backend customer creation and invoice generation

      const currentDate = formatDate(new Date());
      const futureDate = formatDate(new Date(new Date().setFullYear(new Date().getFullYear() + 3)));

      // Mapping items for the invoice
      const invoiceItems = savedItems.map((item) => {

        return mapProduct(item.ton, item);
      });

      // Filter and calculate quantities for installation items
      const splitItems = savedItems.filter(item => item.acType === "Split");
      const cassetteItems = savedItems.filter(item => item.acType === "Cassette");

      const totalSplitQuantity = splitItems.reduce((sum, item) => sum + item.quantity, 0);
      const totalCassetteQuantity = cassetteItems.reduce((sum, item) => sum + item.quantity, 0);

      // Add installation items if applicable
      const splitInstallationItem = createInstallationItem('Split', totalSplitQuantity, splitInstallationCharge, 'install_1500_p');
      const cassetteInstallationItem = createInstallationItem('Cassette', totalCassetteQuantity, cassetteInstallationCharge, 'install_cassette_p');

      if (splitInstallationItem) {
        invoiceItems.push(splitInstallationItem);
      }
      if (cassetteInstallationItem) {
        invoiceItems.push(cassetteInstallationItem);
      }
      savedItems.forEach(item => {
        const acModel = item.acType === 'Cassette' ? 'Cassette' : 'Split';
        let duration = null;
        if (acModel === 'Split') {
          duration = item.plan === "3+2year" ? "5years" : (item.plan || "5years");
        }
        const refundableItem = mapRefundableDeposit(acModel, item.ton, duration, item.quantity,item.totalDeposit);
        refundableItem.total_amount = item.depositamount * item.quantity;
        invoiceItems.push(refundableItem);
      });
      const materialItems = mapMaterial(materials);
      materialItems.forEach(material => {
        if (material) {
          invoiceItems.push(material);
        }
      });
      // Invoice details

      const invoice = {
        document_type: 'pro_forma_invoice',
        document_date: currentDate,
        customer: {
          id: customerdata.customer_id,
          name: customerdata.name,
          email: customerdata.email,
          gstin: billingAddress.gst_number,
        },
        items: invoiceItems,
        customer_shipping_address: {
          address_line1: selectedShippingAddress.line1,
          address_line2: selectedShippingAddress.line2,
          pincode: selectedShippingAddress.pincode,
          city: selectedShippingAddress.city,
          country: 'India',
          state: selectedShippingAddress.state,
        },
        // Conditionally add customer_billing_address if gstin.number exists
        customer_billing_address: {
          address_line1: billingAddress.address_line1,
          address_line2: billingAddress.address_line2,
          pincode: billingAddress.pincode,
          city: billingAddress.city,
          country: 'India',
          state: billingAddress.state,
        }
        ,
        notes: `Start Date : ${currentDate} End Date: ${futureDate}`,
        round_off: true,
      };
      uploadInvoiceData(invoice);
      setIsLoading(true);
      const token = `${process.env.REACT_APP_SWIPE_TOKEN}`;
      const swipeResponse = await axios.post(
        `${process.env.REACT_APP_SWIPE_BASE_URL}/api/partner/v1/doc`,
        invoice,
        {
          headers: {
            Authorization: token
          }
        }
      );
      

      const hashId = swipeResponse.data.hashId;
      const pdfResponse = await axios.get(
        `${process.env.REACT_APP_SWIPE_BASE_URL}/api/partner/v1/doc/pdf/${hashId}`,
        {
          headers: {
            Authorization: token
          },
          responseType: 'arraybuffer'
        }
      );

      const pdfBlob = new Blob([pdfResponse.data], { type: 'application/pdf' });
       const fileName=`invoice_${hashId}.pdf`
       const pdfurl=await uploadPdfToS3(pdfBlob,fileName)
       updateurl(pdfurl,preOrderId)
      const presignedUrl=await generatePresignedUrl(fileName);
      console.log(presignedUrl,"checkurl")
      const formData = new FormData();
      formData.append('pro_forma_invoice', pdfBlob, `invoice_${hashId}.pdf`)
      formData.append('customername', customerdata.name);
      formData.append('customeremail', customerdata.email);
      const pdfUploadResponse = await axios.post(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/generatePI/send-invoice`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );
      setIsLoading(false);
      sendWhatsAppMessage(customerdata.mobile,presignedUrl,customerdata.name,pending_amount)
      alert("📄 Pre-Order Invoice Sent Successfully!");
     
      return swipeResponse;

    } catch (error) {
      setIsLoading(false);
      alert(`Error creating invoice or processing payment: ${error.response ? error.response.data : error.message}`);
    }
  };
  const fetchPreOrderData = async (itemId) => {
    if (itemId !== undefined) {
      try {
        const response = await axios({
          url: `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${itemId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }).then((res) => {

          // Calculate installation charges
          // Extract single installation charges for cassette and split
          let cassetteInstallationCharge = null;
          let splitInstallationCharge = null;

          res.data.AcDetails.forEach((item) => {
            if (cassetteInstallationCharge === null && item.ac_type.toLowerCase() === "cassette") {
              cassetteInstallationCharge = item.installation_price;
            }
            if (splitInstallationCharge === null && item.ac_type.toLowerCase() === "split") {
              splitInstallationCharge = item.installation_price;
            }
          });

          let transformedAcDetails = res.data.AcDetails.map((item) => ({
            acType: item.ac_type,
            ton: item.model.replace(/^[SC]/, ""), // Remove leading 'S' or 'C'
            plan: item.plan_year,
            quantity: item.quantity,
            subscription_plan: item.subscription_price,
            depositamount: item.deposit,
            installetionCharge: item.installation_price,
            totalSubscription: item.subscription_price * item.quantity,
            totalDeposit: item.deposit * item.quantity,
            totalInstallation: item.installation_price * item.quantity,
            priceAfter3Years: item.fixedPriceAfter3Years,
            totalAfter3Years: item.fixedPriceAfter3Years * item.quantity,
            totalAmount:
              item.subscription_price * item.quantity +
              item.deposit * item.quantity +
              item.installation_price * item.quantity,
            fixedPriceAfter3Years: item.fixedPriceAfter3Years,
            id: Date.now() + Math.floor(Math.random() * 1000), // Unique ID
          }));

          // Transforming materials details
          let transformedMaterials = res.data.materialsdetails.map((material) => ({
            materialType: material.material_name,
            quantity: Number(material.quantity),
            price: Number(material.material_price),
            totalAmount: Number(material.quantity) * Number(material.material_price),
          }));
          const selectedAddress = {
            line1: res.data.customer_shipping_address.address_line1,
            line2: res.data.customer_shipping_address.address_line2,
            city: res.data.customer_shipping_address.city,
            state: res.data.customer_shipping_address.state,
            pincode: res.data.customer_shipping_address.pincode,
          };


          let billingAddress = res.data.customer_billing_address;
          if (!res.data.customer_billing_address.gst_number) {
            billingAddress = {
              gst_number: res.data.customer_billing_address.gst_number,
              address_line1: res.data.customer_billing_address.address_line1,
              address_line2: res.data.customer_billing_address.address_line2,
              pincode: res.data.customer_billing_address.pincode,
              city: res.data.customer_billing_address.city,
              state: res.data.customer_billing_address.state,
              country: res.data.customer_billing_address.country,
            };
          }
         createPIInvoice(transformedAcDetails, transformedMaterials, res.data.customer, selectedAddress, billingAddress, splitInstallationCharge, cassetteInstallationCharge,res.data.pending_amount,res.data._id);

        });


      } catch (error) {
        console.error("Error fetching pre-order data:", error);
        // Optional: Show user-friendly error message
      }
    }
  };



  const sendWhatsAppMessage = async (customerMobile, pdfUrl, customerName, invoiceAmount) => {
    console.log("inside the sendWhatsAppMessage function");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_WHATSAPP_URL}`,
        {
          apiKey: process.env.REACT_APP_WHATSAPP_KEY,
          campaignName: 'Pisend',
          destination: `91${customerMobile}`,
          userName: 'PROCYON STAR PRIVATE LIMITED',
          templateParams: [customerName, String(invoiceAmount)],
          source: 'Invoice Process',
          media: {
            url: pdfUrl, // Use the S3 URL here
            filename: `Invoice_${customerName}.pdf`,
          },
          buttons: [],
        }
      );
      console.log('WhatsApp message sent successfully:', response.data);
    } catch (error) {
      console.error('Error sending WhatsApp message:', error.response ? error.response.data : error.message);
      alert('Failed to send WhatsApp message. Please try again.');
    }
  };
  const updateurl = async (pdfurl, preOrderid) => {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/addpilinkurl`,
        {
          preOrderid: preOrderid,
          pilink: pdfurl,
        }
      );
      console.log(res.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };
  

  const handleActionChange = async (e, index, itemId) => {
    let updatedStatus = e.target.value;

    if (updatedStatus === "edit") {
      navigate(`/orders/${itemId}`);
      return;
    } else if (updatedStatus === "PiSent") {
      await fetchPreOrderData(itemId);
      return;
    } else if (updatedStatus === "recordpayment") {
      setIsOpen(!isOpen);
      setid(itemId);
      return;
    } else if (updatedStatus === "site") {
      setIsOpensite(!isOpensite);
      setselectedoderid(itemId);
      return;
    }else if(updatedStatus==="installtion"){
      setIsOpenInstallation(!isOpenInstallation)
      setselectedoderid(itemId);
      return;
    }else if(updatedStatus==="move"){
      await moveToInstalltionHandler(itemId);
      return;
    }

    const itemIndex = (currentPage - 1) * itemsPerPage + index;
    const preOrderId = data[itemIndex]._id;
    const updatedItem = { ...data[itemIndex], status: updatedStatus };
    const newData = [...data];
    newData[itemIndex].status = ""; // Set the status to an empty string
    setData(newData); // Update the UI immediately

    try {
      setIsLoading(true); // Start loading before making API requests

      const preOrderResponse = await axios.get(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${preOrderId}`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );

      let pendingAmount = preOrderResponse.data.pending_amount;
      let paymentLinkData;
      let patchData;
      let confirmMessage;

      if (updatedStatus === "fullpayment" && preOrderResponse.data.with_material === false) {
        confirmMessage = `💰 Confirm Full Payment for Circolife AC. Do you want to proceed?`;
      } else if (updatedStatus === "token") {
        
        let totalQuantity = 0;
        preOrderResponse.data.AcDetails.forEach(ac => {
          totalQuantity += ac.quantity;
        });
        let totaltoken = totalQuantity * 1000;
        if (pendingAmount < totaltoken) {
          alert("❌ Pending amount is less than the token amount. Payment cannot be processed.");
          setIsLoading(false); // Stop loading if the condition is not met
          return; // Exit the function
        }
        pendingAmount=totaltoken
        confirmMessage = `🔑 Confirm Token Payment for Circolife AC. Do you want to proceed?`;
        
      } else if (updatedStatus === "onlymaterial") {
        confirmMessage = `🔧 Confirm Only Material Payment for Circolife AC. Do you want to proceed?`;
      } else if (updatedStatus === "fullpayment" && preOrderResponse.data.with_material === true && preOrderResponse.data.material_totalAmount >= 0) {
        confirmMessage = `💸 Confirm Custom Payment of ${pendingAmount} for Circolife AC. Do you want to proceed?`;
      }

      const userConfirmed = window.confirm(confirmMessage);
      if (!userConfirmed) {
        setIsLoading(false); // Stop loading if the user cancels
        return;
      }

      // Prepare data for payment link based on the status
      if (updatedStatus === "fullpayment" && preOrderResponse.data.with_material === true) {
        paymentLinkData = {
          description: "Circolife AC Full Payment",
          amount: pendingAmount,
          name: preOrderResponse.data.customer.name,
          email: preOrderResponse.data.customer.email,
          contact: preOrderResponse.data.customer.mobile,
          paymentLinktype: "fullpayment",
          customer_id: preOrderResponse.data.customer.customer_id,
          customer: preOrderResponse.data.customer.name,
          preOrderId: preOrderId
        };
      } else if (updatedStatus === "token") {
        paymentLinkData = {
          description: "Circolife AC Token Payment",
          amount: pendingAmount,
          name: preOrderResponse.data.customer.name,
          email: preOrderResponse.data.customer.email,
          contact: preOrderResponse.data.customer.mobile,
          paymentLinktype: "token",
          customer_id: preOrderResponse.data.customer.customer_id,
          customer: preOrderResponse.data.customer.name,
          preOrderId: preOrderId
        };
      } else if (updatedStatus === "fullpayment" && preOrderResponse.data.with_material === false) {
        paymentLinkData = {
          description: "Circolife AC Custom Payment",
          amount: pendingAmount,
          name: preOrderResponse.data.customer.name,
          email: preOrderResponse.data.customer.email,
          contact: preOrderResponse.data.customer.mobile,
          paymentLinktype: "customize",
          customer_id: preOrderResponse.data.customer.customer_id,
          customer: preOrderResponse.data.customer.name,
          preOrderId: preOrderId
        };
      } else if (updatedStatus === "onlymaterial") {
        paymentLinkData = {
          description: "Circolife AC Only Material Payment",
          amount: preOrderResponse.data.material_totalAmount,
          name: preOrderResponse.data.customer.name,
          email: preOrderResponse.data.customer.email,
          contact: preOrderResponse.data.customer.mobile,
          paymentLinktype: "onlymaterial",
          customer_id: preOrderResponse.data.customer.customer_id,
          customer: preOrderResponse.data.customer.name,
          preOrderId: preOrderId
        };
      }

      const paymentResponse = await axios.post(
        `${process.env.REACT_APP_MYBACKEND_PI}/create-payment-link`,
        paymentLinkData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );

      // Prepare patch data for updating the pre-order
      patchData = {
        status: paymentLinkData.paymentLinktype,
        paymentLinkId: paymentResponse.data.paymentLinkUrl,
        tokenAmount: paymentLinkData.amount, // for "token" and "customize"
      };

      // Update pre-order status and payment details
      await axios.patch(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${preOrderId}/status`,
        patchData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );

      newData[itemIndex] = { ...newData[itemIndex], ...patchData };
      setData(newData); // Reflect the update in the UI immediately

      alert("🎉 Payment Link Sent Successfully!");
      fetchData();
    } catch (error) {
      console.error("Error in payment link process:", error.response ? error.response.data : error.message);
      alert("❌ There was an error creating the payment link. Please try again.");
    } finally {
      setIsLoading(false); // End loading after all operations are complete
    }
  };


  const moveToInstalltionHandler=async(id)=>{
    axios({
      url:`${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/newsct/${id}`,
      method:"POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },

    }).then((res)=>{
      console.log(res.data,"ordercreated")
    })
  }




  const handleCheckboxChange = async (index) => {
    const itemIndex = (currentPage - 1) * itemsPerPage + index; // Calculate the actual index in the data array
    const currentItem = data[itemIndex];
    const newWithMaterial = !currentItem.with_material; // Toggle the `with_material` status

    try {
      // Make the PATCH request to update the `with_material` status on the backend
      setIsLoading(true)
      const response = await axios.patch(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${currentItem._id}/withmaterial/${newWithMaterial}`,
        {}, // Pass an empty object as data since it's not required
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );

      // Update the item in the data state with the response data from the backend
      const newData = [...data];
      newData[itemIndex] = response.data;



      setData(newData);
      setIsLoading(false)
    } catch (error) {
      console.error("Failed to update with_material status:", error.message);
      setIsLoading(false)
      alert("Failed to update. Please try again.");
    }
  };
  const modelToTonMapping = {
    "S10": "1 ton",
    "S20": "2 ton",
    "C20": "2 ton",
    "C30": "3 ton",
    "S15": "1.5 ton"
  };






  let user = localStorage.getItem("userName")

  return (
    <div className="flex flex-col w-full h-full p-4">
      <div className="flex justify-between items-center border-b-2 border-gray-300 pb-2 mb-4">
        <p className="text-lg font-semibold">Hello {user}</p>
        <div className="flex items-center">
          <p className="text-primary mr-2 text-2xl">Total Customer:</p>
          <p className="text-primary font-bold text-2xl">{totalOrganizations}</p>
        </div>
      </div>
      <div className="flex flex-wrap justify-between mb-4 gap-4">
        <div className="sm:flex flex-wrap gap-3">
          <div className="flex items-center gap-2 border-2 border-secondary rounded-md px-5 py-2">
            <FontAwesomeIcon icon={faMagnifyingGlass} size="xl" color="#A14996" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-60 text-black outline-none"
              placeholder="Search Customer"
            />
          </div>
        </div>
        <div className="flex-wrap">
          <button
            className="bg-white px-4 py-2 rounded-md text-primary border-primary border-2 mr-2"
            onClick={handleOrderCreation}
          >
            CREATE ORDER
          </button>
          {/* <button
            className="bg-white px-4 py-2 rounded-md text-primary border-primary border-2 mr-2"
            onClick={quryhandler}
          >
            RAISE QUERY
          </button> */}
          <button
            className="text-white px-4 py-2 rounded-md bg-primary"
            onClick={handleLogout}
          >
            <FontAwesomeIcon className="mr-1" icon={faRightFromBracket} />
            Logout
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        {loading ? (
          <p className="text-center">Loading data...</p>
        ) : totalOrganizations === 0 ? (
          <p className="text-center">No data available.</p>
        ) : (
          <>
            <table className="table-auto w-full border-collapse text-sm sm:text-base">
              <thead>
                <tr className="bg-secondary">
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Customer</th>
                  <th colSpan="3" className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Order Details</th>
                  {/* <th colSpan="5" className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Payment Status</th> */}
                </tr>
                <tr className="bg-secondary">
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2"></th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Action</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Ac Details</th>
                  {/* <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Add Material payment</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Pending Amount</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Paid Amount</th> */}
                  {/* <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Link</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Link Status</th> */}
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, index) => (
                  <tr key={index} className="border-t border-gray-300">
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {item.customer.name}
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      <select
                        value={""}
                        onChange={(e) => handleActionChange(e, index, item._id)} // Pass item._id to the handler
                        className="border rounded px-2 py-1 bg-white focus:outline-none focus:ring-2 focus:ring-secondary"
                      >
                        {/* <option value="PISent">Select</option> */}
                        <option value="">Select</option>
                        <option value="edit">Edit</option>
                        <option value="move"> Move To Assign</option>
                        {/* <option value="PiSent">Send PI</option>
                        <option value="token">Take Token</option>
                        {item.materialsdetails.length > 0 ? <option value="onlymaterial">Only Material Payment</option> : ''}
                        <option value="recordpayment"> Record Payment</option>
                        <option value="fullpayment">Full Payment</option>
                        {item.pending_amount==0 ?<option value="installtion"> Request Installation</option>:''} */}
                      </select>
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {/* AC Details */}
                      {item.AcDetails.map((acDetail) => {
                        const tonnage = modelToTonMapping[acDetail.model] || "Unknown ton";
                        return `${acDetail.ac_type} - ${acDetail.quantity} AC (${tonnage})`;
                      }).join(', ')}

                      {/* Divider if materials exist */}
                      {item.materialsdetails && item.materialsdetails.length > 0 && <br />}

                      {/* Materials Details */}
                      {item.materialsdetails && item.materialsdetails.length > 0 &&
                        item.materialsdetails.map((material) => {
                          // Check if the material name contains "copper"
                          const unit = material.material_name.toLowerCase().includes('copper') ? 'feet' : 'pcs';
                          return `${material.material_name} - ${material.quantity} ${unit}`;
                        }).join(', ')}
                    </td>

                    {/* <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2 text-center">
                      <input
                        type="checkbox"
                        checked={item.with_material}
                        onChange={() => handleCheckboxChange(index)}
                        className="form-checkbox h-4 w-4 text-secondary"
                      />
                    </td> */}

                    {/* <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {item.pending_amount}
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {item.paidamount}
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
            {isLoading && (
              <div className="fixed inset-0 bg-gray-50 bg-opacity-70 overflow-y-auto h-full w-full flex items-center justify-center">
                <LoadingAnimation />
              </div>
            )}


            {/* Modal */}
            {isOpen && (
              <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4 p-6">
                  <h3 className="text-lg font-semibold mb-4">Record Payment</h3>
                  <div className="mb-4 flex items-center gap-x-6">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        value="normal"
                        checked={approvalType === "normal"}
                        onChange={() => setApprovalType("normal")}
                        className="mr-2"
                      />
                      Normal Approval
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        value="special"
                        checked={approvalType === "special"}
                        onChange={() => setApprovalType("special")}
                        className="mr-2"
                      />
                      Special Approval
                    </label>
                  </div>
                  {approvalType === "normal" ? (
                    <>
                      {/* Document Type Dropdown */}
                      <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Document Type:</label>
                        <select
                          value={recordType}
                          onChange={(e) => setrecordType(e.target.value)}
                          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                        >
                          <option value="" disabled>
                            Select Document Type
                          </option>
                          <option value="cheque">Cheque</option>
                          <option value="qrcode">QR Code</option>
                        </select>
                      </div>

                      {/* File Upload */}
                      <div className="mb-4">
                        <label
                          htmlFor="attachment"
                          className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer hover:bg-blue-600 transition"
                        >
                          Upload Attachment
                        </label>
                        <input
                          type="file"
                          id="attachment"
                          onChange={handleFileUpload}
                          className="hidden"
                        />
                        {attachment && (
                          <div className="mt-2">
                            <div className="flex items-center space-x-2">
                              <span className="text-sm text-gray-600">{attachment.name}</span>
                              <button
                                onClick={removeAttachment}
                                className="text-red-500 hover:underline text-sm"
                              >
                                Delete
                              </button>
                            </div>
                            {attachmentPreview && (
                              <div className="mt-2">
                                <img
                                  src={attachmentPreview}
                                  alt="Preview"
                                  className="w-48 h-32 object-cover rounded border border-gray-300"
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Total Amount */}
                      <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Enter Total Amount:</label>
                        <input
                          type="text"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          placeholder="₹"
                          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {/* Special Approval Comment */}
                      <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Write a Comment:</label>
                        <textarea
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          placeholder="Add your comments here..."
                          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                        ></textarea>
                      </div>
                    </>
                  )}

                  {/* Action Buttons */}
                  <div className="flex justify-end space-x-4">
                    <button
                      onClick={toggleModal}
                      className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100 transition"
                    >
                      Cancel
                    </button>
                    <button
                      className="px-4 py-2 bg-primary text-white rounded hover:bg-purple-700 transition"
                      onClick={handleSubmit}
                    >
                      Send Approval Request
                    </button>
                  </div>
                </div>
              </div>
            )}
            {isOpensite && (
              <SiteSurvey siteSurvey={siteSurvey} setSiteSurvey={setSiteSurvey} isOpensite={isOpensite} setIsOpensite={setIsOpensite} selectpreoderid={selectpreoderid} />
            )

            }
            {isOpenInstallation &&(
              <Installation isOpenInstallation={isOpenInstallation} setIsOpenInstallation={setIsOpenInstallation} setInstallationDetails={setInstallationDetails} installationDetails={installationDetails} selectpreoderid={selectpreoderid}/>
            )

            }
           


            {/* Pagination */}
            <div className="flex justify-center items-center space-x-2 mt-[1%]">
              <button
                className="bg-gray-300 hover:bg-gray-400 text-black py-1 px-3 rounded"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              {Array.from({ length: Math.ceil(filteredData.length / itemsPerPage) }, (_, index) => (
                <button
                  key={index + 1}
                  className={`py-1 px-3 rounded ${currentPage === index + 1
                    ? "bg-primary text-white"
                    : "bg-gray-300 hover:bg-gray-400 text-black"
                    }`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              <button
                className="bg-gray-300 hover:bg-gray-400 text-black py-1 px-3 rounded"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default HomeBackend;
